const ModelCustomizerController = {
    init() {
        this.isCustomizerReady = false
        this.queue = []

        this.bindEvents()
    },

    bindEvents() {
        document.addEventListener('customizer-ready',() => {
            this.isCustomizerReady = true
            this.queue.forEach(command => {
                this.execute(command)
            })
        })
    },

    execute(command) {
        if(!this.isCustomizerReady) {
            this.queue.push(command)
        }
        else {
            document.dispatchEvent(
                new CustomEvent(
                    'execute',
                    { detail: { args: JSON.parse(command) } }
                )
            )
        }
    }
}
ModelCustomizerController.init()